
@switch (columnId) {
  @case ('token') {
    <lib-text-table-column>
      {{ element?.token }}
    </lib-text-table-column>
  }
  @case ('dateExpired') {
    <lib-date-time-label [dateUtc]="element?.dateExpired">
    </lib-date-time-label>
    <lib-table-column-sort [key]="sortingKeyForDateExpired"></lib-table-column-sort>
  }
  @case ('dateCreated') {
    <lib-date-time-label [dateUtc]="element?.dateCreated">
    </lib-date-time-label>
    <lib-table-column-sort [key]="sortingKeyForDateCreated"></lib-table-column-sort>
  }
  @case ('order') {
    @if ((element?.status === DigitalWalletCertificateStatusEnum.New) || (element?.status === DigitalWalletCertificateStatusEnum.Registered)) {
      <lib-text-table-column>
        {{ element?.order }}
      </lib-text-table-column>
    } @else {
      <lib-text-table-column>
      </lib-text-table-column>
    }
  }
  @case ('status') {
    <lib-status-chip
      class="certificate-statuses"
      [status]="element?.status">
    </lib-status-chip>
  }
  @case ('actions') {
    <div class="action-buttons-container">
      @if (element?.status !== DigitalWalletCertificateStatusEnum.Revoked) {
        <lib-action-button
          [kind]="actionButtonKind"
          label="Revoke"
          [fontImage]="fontImageForRevoke"
          [iconAfterText]="actionButtonIconAfterText"
          (click)="onClickRevoke()">
        </lib-action-button>
      }
    </div>
  }
  @default {
  }
}





